/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import Modal from '../../../../../components/Modal/Modal';
import { PrimaryButton, GhostButton } from '../../../../../styles/ui/Button';
import { scheduleInterview } from '../../../../../services/hr/recruitment/interviewsApi';
import { defaultModalityForRound } from '../../constants';
import { toIsoWithOffset } from '../../utils/format';
import { readApiError, recruitmentErrorMessage } from '../../utils/apiError';
import InterviewScheduleFields from './InterviewScheduleFields';

// ---------------------------------------------------------------------------
// Agendar a entrevista da rodada atual (round derivado do stage). Exige o
// candidato no stage certo e nenhuma entrevista ativa da rodada (guards do
// backend). Modalidade default: E1 = ONLINE, E2 = PRESENCIAL.
// ---------------------------------------------------------------------------

export default function ScheduleInterviewModal({
   isOpen,
   onClose,
   candidateId,
   round,
   onSaved,
}) {
   const [modality, setModality] = useState(defaultModalityForRound(round));
   const [interviewerId, setInterviewerId] = useState('');
   const [scheduledAt, setScheduledAt] = useState('');
   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   useEffect(() => {
      if (isOpen) {
         setModality(defaultModalityForRound(round));
         setInterviewerId('');
         setScheduledAt('');
         setErrors({});
         setIsSubmitting(false);
      }
   }, [isOpen, round]);

   const handleConfirm = async () => {
      if (isSubmitting) return;
      if (!scheduledAt) {
         setErrors({ scheduled_at: 'Informe a data e a hora.' });
         return;
      }

      setIsSubmitting(true);
      setErrors({});
      try {
         const { message } = await scheduleInterview(candidateId, {
            round,
            modality,
            interviewerUserId: interviewerId ? Number(interviewerId) : undefined,
            scheduledAt: toIsoWithOffset(scheduledAt),
         });
         toast.success(message);
         onSaved?.();
         onClose?.();
      } catch (err) {
         const { fieldErrors } = readApiError(err);
         if (Object.keys(fieldErrors).length > 0) {
            setErrors(fieldErrors);
         } else {
            toast.error(
               recruitmentErrorMessage(err, 'Erro ao agendar a entrevista.'),
            );
         }
      } finally {
         setIsSubmitting(false);
      }
   };

   const footer = (
      <>
         <GhostButton type="button" onClick={onClose} disabled={isSubmitting}>
            Cancelar
         </GhostButton>
         <PrimaryButton
            type="button"
            onClick={handleConfirm}
            disabled={isSubmitting}
         >
            {isSubmitting ? 'Agendando…' : 'Agendar entrevista'}
         </PrimaryButton>
      </>
   );

   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         title={`Agendar Entrevista ${round}`}
         maxWidth="560px"
         footer={footer}
      >
         <InterviewScheduleFields
            modality={modality}
            onModality={setModality}
            interviewerId={interviewerId}
            onInterviewer={setInterviewerId}
            scheduledAt={scheduledAt}
            onScheduledAt={setScheduledAt}
            disabled={isSubmitting}
            errors={errors}
         />
      </Modal>
   );
}

ScheduleInterviewModal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   candidateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
   round: PropTypes.number.isRequired,
   onSaved: PropTypes.func,
};
